import { IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
const Wrapper = styled("div")({
  height: 80,
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center"
});
const Option = styled(IconButton)(({ theme }) => ({
  height: 32,
  border: `1px solid ${theme.palette.grey[600]}`,
  borderRadius: 8,
  fontFamily: "Lato",
  fontWeight: 700,
  fontSize: 14,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  textAlign: "center",
  display: "inline-flex",
  alignItems: "center",
  paddingLeft: 15,
  paddingRight: 15,
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(1)
}));
export {
  Option,
  Wrapper
};
